import { createApp, ref } from 'vue';
import common from '@page/common/js/common';
import $ from 'jquery';

import fireShopListViewEvent, { firePromotionEvent } from '@global/gtm/shopList/shopListView';
import fireShopListClickGTMEvent from '@global/gtm/shopList/clickList';

import useModalStore from '@global/stores/useModalStore';
import useDialog from '@composable/useDialog';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';

import Pagination from '@global/components/common/pagination/PaginationLayout.vue';
import WishBtn from '@components/WishBtn.vue';
import ShareBtn from '@components/ShareBtn.vue';
import CartDialog from '@components/CartDialog.vue';
import FoodDialog from '@components/FoodDialog.vue';
import SortApp from '@page/shop/components/SortApp.vue';

const { openDialog, openFoodDialog } = useDialog();
const { getSortConditionAPI } = useAxiosAPI();

require('@global/vendors/jquery.sticky-kit');

const app = createApp({
  components: {
    Pagination,
    WishBtn,
    ShareBtn,
    SortApp,
    CartDialog,
    FoodDialog,
  },
  setup() {
    const modalStore = useModalStore();
    const { openModal } = modalStore;
    const largeMode = ref(false);
    const sortConditionDatas = ref({});
    const sortConditionIsLoad = ref(false);

    getSortCondition();

    function getSortCondition() {
      getSortConditionAPI()
        .then((res) => {
          if (res.data.Code === 200) {
            sortConditionDatas.value = res.data.Response;
            sortConditionIsLoad.value = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }

    function fireGTM(customMarketID) {
      fireShopListClickGTMEvent({ customMarketID });
    }

    return {
      largeMode,
      sortConditionDatas,
      sortConditionIsLoad,
      getSortCondition,
      fireGTM,
      openDialog,
      openFoodDialog,
      openModal,
    };
  },
});

app.mount('#app-shop');

$('.product-menu-pc').stick_in_parent({ offset_top: 180 });

// 刪除後端加上的手機版過濾
if (window.innerWidth >= 768) {
  $('#sort-app-mb').remove();
}

$(window).scroll(() => {
  if ($(window).scrollTop() > 0) {
    $('#sort-arrow').css('position', 'static');
    $('#sort-app-mb').css('position', 'static');
    $('.first-menu-mb').css('left', '0');
  } else {
    $('#sort-arrow').css('position', 'fixed');
    $('#sort-app-mb').css('position', 'fixed');
    if (!$('#sort-arrow').length) {
      $('.first-menu-mb').css('left', '50px');
    } else {
      $('.first-menu-mb').css('left', '100px');
    }
  }
});

// $('#sort-app-mb').click(() => {
//   $('#sort-app-mb').css('position', 'static');

//   if ($(window).scrollTop() > 0) {
//     $('.first-menu-mb').css('left', '0');
//   } else {
//     if ($('#sort-arrow').length) {
//       $('.first-menu-mb').css('left', '50px');
//       return;
//     }

//     $('.first-menu-mb').css('left', '0');
//   }
// });

// $('#lb-sort .modal-close').click(() => {
//   $('#sort-app-mb').css('position', 'fixed');
// });

if ($('#sort-arrow').length) {
  $('#sort-app-mb').css('left', '70px');
  $('.first-menu-mb').css('left', '100px');
} else {
  $('#sort-app-mb').css('left', '20px');
  $('.first-menu-mb').css('left', '50px');
}

fireShopListViewEvent();
firePromotionEvent();
